import type { BusinessLogicCallbackArgs, EagerJobsTbdSdk } from '@fiverr-private/jtbd_sdk';

import { getJobInfo } from './utils/getJobInfo';

export const ProjectManagementCardImpl = {
    getJobInfo,
    cardCallbacks: {
        customActionCallback: (args?: BusinessLogicCallbackArgs) => {
            args?.hanlders.openModal();
        },
    },
} satisfies EagerJobsTbdSdk;
